import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { filesAPI } from '../services/api';

export const useFiles = (entityType: string, entityId: string) => {
  const queryClient = useQueryClient();

  // Get files for entity
  const {
    data: files = [],
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['files', entityType, entityId],
    queryFn: () => filesAPI.getByEntity(entityType, entityId),
    enabled: !!entityType && !!entityId,
  });

  // Upload file mutation
  const uploadFile = useMutation({
    mutationFn: ({ file, originalName }: { file: File; originalName?: string }) => 
      filesAPI.upload(file, entityType, entityId, originalName),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['files', entityType, entityId] });
    },
  });

  // Delete file mutation
  const deleteFile = useMutation({
    mutationFn: filesAPI.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['files', entityType, entityId] });
    },
  });

  return {
    files,
    isLoading,
    error,
    refetch,
    uploadFile: uploadFile.mutate,
    deleteFile: deleteFile.mutate,
    isUploading: uploadFile.isPending,
    isDeleting: deleteFile.isPending,
  };
};

export const useFileDownload = () => {
  const downloadFile = async (fileId: string) => {
    try {
      const response = await filesAPI.download(fileId);
      return response;
    } catch (error) {
      console.error('Download failed:', error);
      throw error;
    }
  };

  return { downloadFile };
};
